import { SxProps, Theme } from '@mui/material';
import { CatalogVariant } from '../../../types/catalog';
import { ProductInView } from '../../../utils/catalog/catalogFilters';

// rows are separate grids, so only fixed tracks keep their columns aligned
const LIBRARY_COLUMNS = {
  xs: '24px minmax(0, 1fr) 104px 40px',
  sm: '24px minmax(0, 1fr) 132px 120px 48px',
  lg: '24px minmax(0, 1fr) 180px 160px 48px',
};

export const HIDE_ON_PHONE = { xs: 'none', sm: 'block' };
export const THUMB_GAP = 1.5;

export const libraryRowSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: LIBRARY_COLUMNS,
  alignItems: 'center',
  columnGap: { xs: 1, sm: 2 },
  px: { xs: 1, sm: 2 },
  minHeight: 64,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export type LibraryRow =
  | { kind: 'product'; entry: ProductInView }
  | { kind: 'variant'; entry: ProductInView; variant: CatalogVariant };

// a standalone item is its own product and variant, so both rows share an id
export const libraryRowKey = (_: number, row: LibraryRow) =>
  row.kind === 'product'
    ? `product-${row.entry.product.id}`
    : `variant-${row.variant.id}`;
